module.exports = __webpack_public_path__ + "img/tower.69ce86c3.png";